/* eslint-disable no-invalid-this */

import ApiService, { ACCOUNTS_API_CONTEXT, ACCOUNTS_API_HOST } from './ApiService';

/**
 * @override
 */
class ProductsService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: ACCOUNTS_API_HOST });
    }

    /**
     * Get products list
     * @param {Object} sort Sort
     * @param {Object} config Axios config
     * @return {Object} Response with list of products
     */
    getProducts = (sort, config) => {
        if (!config.params) {
            config.params = {};
        }
        if (!config.params.$limit) {
            config.params.$limit = 9999;
        }
        if (sort.trim() !== '') {
            return this.getList(`${ACCOUNTS_API_CONTEXT}/products?$orderby=${sort}`, config);
        } else {
            return this.getList(`${ACCOUNTS_API_CONTEXT}/products`, config);
        }
    };
    /**
     * Get minimum investment info for a product
     * @param {String} id product key_name
     * @param {Object} config Axios config (params: investor_class, is_employed, etc.)
     * @return {Object} Response with calculated minimums
     */
    getMinimums = ( config ) => {
        return this.get(`${ACCOUNTS_API_CONTEXT}/get-minimums`, config);
    };
    /**
     * @param {String} url Url
     * @param {Object} config Axios config
     * @return {Object} Response with list of products
     */
    getPagination = (url, config) => this.get(`${url}`, config);
    /**
     * Buscar operaciones
     * @param {Array} search Búsqueda
     * @param {Object} config Axios config
     * @return {Object} Response with opertaions
     */
    getSearch = (search, config) => this.getList(`${ACCOUNTS_API_CONTEXT}/products?$search=${search}`, config);
}

const productsService = new ProductsService();

export default productsService;
